export default [
  {
    path: '*',
    redirect: { name: '400' }
  },
  {
    path: '/erro/400',
    name: '400',
    component: () => import('../views/400')
  },
  {
    path: '/erro/401',
    name: '401',
    component: () => import('../views/401')
  },
  {
    path: '/erro/404',
    name: '404',
    component: () => import('../views/404')
  },
  {
    path: '/:uuid',
    name: 'Home',
    component: () => import('../views/Home')
  }, {
    path: '/veiculo/listar',
    name: 'Veiculos',
    component: () => import('../views/Veiculos')
  }, {
    path: '/veiculo/detalhes',
    name: 'VeiculoDetalhes',
    component: () => import('../views/Veiculo')
  }
]
